import React from "react";
import TopLine from "../common/TopLine";
import List from "../common/List/List";
import TitleCell from "../common/List/TitleCell";
import uniqid from "uniqid";
import ParkingRow from "./ParkingRow";

const ParkingList = ({ parkingSpaces }) => {
  const titles = [
    "車位編號",
    "樓層",
    "租賃人數",
    "住戶姓名",
    "房號",
    "聯絡電話",
    "租期",
  ];
  return (
    <div>
      <TopLine />
      {/* expand if possible */}
      <List gridCols="grid-cols-[repeat(7,minmax(min-content,1fr))]">
        {titles.map((text) => (
          <TitleCell
            key={uniqid()}
            text={text}
            className="whitespace-nowrap px-2"
          />
        ))}
        {parkingSpaces?.map((ps) => (
          <ParkingRow key={uniqid()} parkingSpace={ps} />
        ))}
      </List>
    </div>
  );
};

export default ParkingList;
